import { render, staticRenderFns } from "./associatModel.vue?vue&type=template&id=b347bd90&scoped=true&"
import script from "./associatModel.vue?vue&type=script&lang=js&"
export * from "./associatModel.vue?vue&type=script&lang=js&"
import style0 from "./associatModel.vue?vue&type=style&index=0&id=b347bd90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b347bd90",
  null
  
)

export default component.exports